import React from 'react'

export const ChatDelete = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6773)'>
      <path
        d='M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM13.415 11L15.889 8.525L14.475 7.111L12 9.586L9.525 7.11L8.111 8.525L10.586 11L8.11 13.475L9.524 14.889L12 12.414L14.475 14.889L15.889 13.475L13.414 11H13.415Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6773'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
